// Keys for graphy's NATIVE feature-flag engine (`/api/admin/feature_flags`),
// read through `useFeatureFlag`. Distinct from `FEATURE_TOGGLE` in
// ./featuretoggle, which holds GrowthBook keys read through `useFeatureValue`
// — two different backends, so keeping the key lists apart stops a key being
// handed to the wrong hook (which fails silently as a permanent `false`).
//
// Each key must match a `feature_flags.key` row in graphy exactly; an unknown
// key resolves to 'off' rather than erroring, so a typo here is invisible.

export const NATIVE_FEATURE_FLAG = {
  /**
   * A/B: the GRAVY-10265 preferred-staffing modal. Variant-valued
   * ('treatment' | 'control'), not a simple on/off.
   */
  PreferredStaffingModal: 'v2.2507.17_preferred-staffing-modal',

  /**
   * Kill switch for the v2 dependability subsystem. Mirrors
   * `Workers::Dependability::Config::FLAG_KEY` in graphy, which gates the
   * dependability endpoints, the score-event callbacks AND the tier data in
   * worker search — so reading this key is what tells the UI that a
   * tier-narrowed search will actually be honoured.
   * On/off-valued: `'on'` when the flag's `default_enabled` is set.
   */
  WorkerDependabilityV2: 'v2.2507.31_worker-dependability-v2',
  /**
   * GRAVY-10436: the rebuilt GravyWorkers page (funnel cards, new table, Last
   * active + Progress filters). On/off-valued; 'on' mounts the new page on
   * /workers_v2, anything else mounts the legacy WorkersV2 page.
   */
  GravyWorkersActivation: 'v2.2508.28_gravyworkers-activation-funnel',
} as const;

export default NATIVE_FEATURE_FLAG;
